(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !window.DesignMode) return;
  try {
    
$(function(){
  var select = $('.select');
  var selected = $('#selected');

  select.on('change', function(){
    console.log('change');
    var selectedOptionText = $(this).children(':selected').text();
    $('#products').hide();
    $('#order').hide();
    $('#coverage').hide();
    $('#company').hide();
    if (selectedOptionText == '商品問い合わせ'){
      $('#products').show();
      $('#products .input').attr('required', true);
      $('#order .input').attr('required', false);
      $('#coverage .input').attr('required', false);
      $('#company .input').attr('required', false);
    } else if (selectedOptionText == '注文に関して') {
      $('#order').show();
      $('#order .input').attr('required', true);
      $('#products .input').attr('required', false);
      $('#coverage .input').attr('required', false);
      $('#company .input').attr('required', false);
    } else if (selectedOptionText == '取材') {
      $('#company').show();
      $('#company .input').attr('required', true);
      $('#products .input').attr('required', false);
      $('#coverage .input').attr('required', false);
      $('#order .input').attr('required', false);
    } else if (selectedOptionText == 'お取り扱いに関して') {
      $('#company').show();
      $('#company .input').attr('required', true);
      $('#products .input').attr('required', false);
      $('#coverage .input').attr('required', false);
      $('#order .input').attr('required', false);
    }
  });
});
$(function() {
    // remove form validation
    $('form').find('input textarea select').removeAttr('required max min maxlength pattern');
});

  } catch(e) { console.error(e); }
})();
})();
